import { useUnit } from 'effector-react';
import { gameModel } from 'entities/game';
import { ActionIcon } from 'shared/ui';
import CrossIcon from 'shared/ui/assets/icons/cross-icon.svg?react';
import MenuIcon from 'shared/ui/assets/icons/menu-icon.svg?react';
import { sidebarModel } from '../../model';
import cls from './sidebar-button.module.scss';

export const SidebarButton = () => {
	const switcher = useUnit(sidebarModel.switcher);
	const isOnboarding = useUnit(gameModel.$isOnboarding);

	return (
		<ActionIcon
			tabIndex={isOnboarding ? -1 : undefined}
			className={cls.sidebarButton}
			data-readonly={isOnboarding || undefined}
			onClick={() => !isOnboarding && switcher.toggle()}
		>
			{switcher.active ? <CrossIcon /> : <MenuIcon />}
		</ActionIcon>
	);
};
